const PATHS = {
  phone: (
    <>
      <circle cx="26" cy="40" r="17" />
      <path d="M9 40h34M26 23c-6 5-6 29 0 34M26 23c6 5 6 29 0 34M12 31h28M12 49h28" />
      <g transform="translate(24 2) scale(1.6)">
        <path vectorEffect="non-scaling-stroke" fill="#3E3E3E" fillOpacity="0" d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </g>
    </>
  ),
  cursor: <path d="M18 8l30 24-13 2 8 16-6 3-8-16-11 9z" />,
  bubble: (
    <>
      <path d="M32 9c13 0 23 9 23 21s-10 21-23 21c-3 0-6-1-9-2l-11 5 3-10c-4-4-6-9-6-14 0-12 10-21 23-21z" />
      <circle cx="23" cy="30" r="1.6" fill="currentColor" />
      <circle cx="32" cy="30" r="1.6" fill="currentColor" />
      <circle cx="41" cy="30" r="1.6" fill="currentColor" />
    </>
  ),
  box: (
    <>
      <path d="M10 30l22-9 22 9-22 9z" />
      <path d="M10 30v16l22 10 22-10V30M32 39v17" />
      <path d="M10 30l-5 7 22 9 5-7M54 30l5 7-22 9-5-7" />
      <path d="M32 26V5M25 12l7-7 7 7" />
    </>
  ),
  headset: (
    <>
      <path d="M12 38v-6a20 20 0 0 1 40 0v6" />
      <rect x="8" y="36" width="10" height="15" rx="4" />
      <rect x="46" y="36" width="10" height="15" rx="4" />
      <path d="M51 51c0 5-5 8-12 8h-5" />
    </>
  ),
  network: (
    <>
      <rect x="24" y="6" width="16" height="12" rx="4" />
      <rect x="5" y="45" width="16" height="12" rx="4" />
      <rect x="24" y="45" width="16" height="12" rx="4" />
      <rect x="43" y="45" width="16" height="12" rx="4" />
      <path d="M32 18v27M13 45v-9h38v9" />
    </>
  ),
  cloud: (
    <>
      <path d="M19 48h27a11 11 0 0 0 1-22 15 15 0 0 0-29-1 11.5 11.5 0 0 0 1 23z" />
      <path d="M32 31v11M27 37l5 5 5-5" />
    </>
  ),
  screen: (
    <>
      <rect x="7" y="9" width="50" height="32" rx="9" />
      <path d="M24 56c0-5 3-8 8-8s8 3 8 8M32 41v7" />
    </>
  ),
};

export const Pictogram = ({ name, color = "currentColor", size = 56, className = "", strokeWidth = 3 }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    style={{ color }}
    aria-hidden="true"
  >
    {PATHS[name]}
  </svg>
);
